import { Controller } from "@hotwired/stimulus"
import { get } from '@rails/request.js'

// Connects to data-controller="service-visits--form"
export default class extends Controller {
    static targets = ['ownerSelect']

    connect() {
        // Listen for turbo:before-stream-render to catch when location select is updated
        document.addEventListener('turbo:before-stream-render', this.handleTurboStreamRender.bind(this))
    }

    disconnect() {
        document.removeEventListener('turbo:before-stream-render', this.handleTurboStreamRender.bind(this))
    }

    handleTurboStreamRender(event) {
        const { target, action } = event.detail.newStream

        // If the location select is being updated, reinitialize Select2 after render
        if (target === 'service_visit_location_id' && action === 'update') {
            // Use setTimeout to ensure the DOM has been updated
            setTimeout(() => {
                const locationSelect = document.getElementById('service_visit_location_id')

                if (locationSelect) {
                    const $select = $(locationSelect)

                    // Destroy existing Select2
                    if ($select.hasClass('select2-hidden-accessible')) {
                        $select.select2('destroy')
                    }

                    // Reinitialize Select2
                    $select.select2({})

                    // Ensure Select2 triggers change events
                    $select.off('select2:select')
                    $select.on('select2:select', function (e) {
                        $(this).trigger('change')
                        this.dispatchEvent(new Event('change', { bubbles: true }))
                    })
                }
            }, 10)
        }
    }

    updateLocationOptions(e) {
        get(e.target.dataset.updatePath, {
            query: {service_visit_owner_id: e.target.value},
            responseKind: 'turbo-stream'
        })
    }

    updateLocationOptionsByType(e) {
        const ownerId = this.ownerSelectTarget.value;

        get(e.target.dataset.updatePath, {
            query: {
                location_type_id: e.target.value,
                service_visit_owner_id: ownerId
            },
            responseKind: 'turbo-stream'
        })
    }

    updatePerformedServicesLockers(e) {
        const updatePath = e.target.dataset.updatePath
        if (!updatePath) {
            return
        }
        get(updatePath, {
            query: { location_id: e.target.value },
            responseKind: 'turbo-stream'
        })
    }

}
